import { Outlet } from 'react-router-dom';
import { Box, ContentPanel, PageFilters, Svg } from '@hopskipdrive/react-components';

import { actions, Can, subjects } from '../../contexts/AbilityContext';
import { ButtonLink } from '../../shared/components';
import { UserFilterSection } from '../components/UserFilterSection';
import { UsersTable } from '../components/UsersTable';

export const OrganizerList = () => {
  return (
    <>
      <Box
        data-testid="organizer-actions"
        style={{ gridArea: 'actions', justifySelf: 'end' }}
        display="flex"
        gap="24px"
        alignItems="center"
      >
        <Can I={actions.add} a={subjects.organizer}>
          <ButtonLink color="primary" size="medium" to="/settings/organizers/new" style={{ gap: '8px' }}>
            <Svg icon="add-filled" />
            {'Add Organizer User'}
          </ButtonLink>
        </Can>
      </Box>
      <PageFilters style={{ gridArea: 'filters' }}>
        <UserFilterSection />
      </PageFilters>
      <ContentPanel sx={{ gridArea: 'content', overflow: 'auto' }}>
        <UsersTable />
      </ContentPanel>
      <Outlet />
    </>
  );
};
